import React from "react";
import Pack from "../components/pack/pack";

export default function OfferRouter() {
  return <Pack />;
}
